import EmbeddedFormBlock from "./embedded-form-block.js";
import { countries, usStates, caStates, auStates, nzStates, cnStates } from "./dynamics-picklist-codes.js";

export default class ProductRegistration {
    constructor(data, elements) {
        this.data = data; // form submitted data
        this.elements = elements; // form elements to get field freindly name
        
        this.embeddedFormBlockCntnr = document.querySelector("[data-embedded-form-block]");
        if (this.embeddedFormBlockCntnr !== null) {
            this.embeddedFormBlock = new EmbeddedFormBlock(this.embeddedFormBlockCntnr);
            this.embeddedFormFields = window.embeddedForms[this.embeddedFormBlock.elementId]; // d365 form field ids
        }
    }

    populateTextField(fieldId, fieldValue) {
        const field = document.getElementById(fieldId);
        if (!field)
            return;

        field.value = fieldValue;
    }

    populateCheckbox(fieldId, fieldValue) {
        const yes = ["Yes", "N"];
        if (!yes.includes(fieldValue))
            return;

        const field = document.getElementById(fieldId);
        if (!field)
            return;

        field.checked = true;
    }

    populateRadio(fieldId, fieldValue) {
        var targetField;
        switch (fieldValue) {
            case "Y":
                targetField = `${fieldId}_0`;
                break;
            case "N":
                targetField = `${fieldId}_1`;
                break;
        }
        const field = document.getElementById(targetField);
        if (!field)
            return;

        field.checked = true;
    }

    populateLookup(fieldId, val, codesArray) {
        const code = codesArray.find(c => c.id === val);
        const input = document.getElementById(fieldId);

        if (!input)
            return;
        input.setAttribute("data-value", code.dataValue);
    }

    populateEmbeddedForm() {
        var country;
        var state;

        for (var d of this.data) {
            var key = d[0];
            var val = d[1];
            var field = this.elements[key];

            if (typeof field !== "undefined") {
                var fieldName = field["friendlyName"];

                switch (fieldName) {
                    case "firstName":
                        this.populateTextField(this.embeddedFormFields.get("firstname"), val);
                        break;
                    case "lastName":
                        this.populateTextField(this.embeddedFormFields.get("lastname"), val);
                        break;
                    case "email":
                        this.populateTextField(this.embeddedFormFields.get("email"), val);
                        break;
                    case "phone":
                        this.populateTextField(this.embeddedFormFields.get("phone"), val);
                        break;
                    case "address1":
                        this.populateTextField(this.embeddedFormFields.get("address1"), val);
                        break;
                    case "address2":
                        this.populateTextField(this.embeddedFormFields.get("address2"), val);
                        break;
                    case "city":
                        this.populateTextField(this.embeddedFormFields.get("city"), val);
                        break;
                    case "zipPostal":
                        this.populateTextField(this.embeddedFormFields.get("zip"), val);
                        break;
                    case "company":
                        this.populateTextField(this.embeddedFormFields.get("company"), val);
                        break;
                    case "serialNumber":
                        this.populateTextField(this.embeddedFormFields.get("serialnumber"), val);
                        break;
                    case "privacyPolicy":
                        this.populateCheckbox(this.embeddedFormFields.get("privacypolicy"),val);
                        break;
                    case "emailPreference":
                        this.populateRadio(this.embeddedFormFields.get("emailpreference"), val);
                        break;
                    case "country":
                        country = val;
                        this.populateLookup(this.embeddedFormFields.get("country"), val, countries);
                        break;
                    case "stateProv":
                        state = val;
                        break;
                    default:
                }
            }
        }

        if (country === "US" || country === "AU" || country === "NZ" || country === "CA" || country === "CN") {
            var codesArray;

            switch (country) {
                case "US":
                    codesArray = usStates;
                    break;
                case "AU":
                    codesArray = auStates;
                    break;
                case "NZ":
                    codesArray = nzStates;
                    break;
                case "CA":
                    codesArray = caStates;
                    break;
                case "CN":
                    codesArray = cnStates;
                    break;

                default:
            }
            this.populateLookup(this.embeddedFormFields.get("state"), state, codesArray);
        }

        let form = this.embeddedFormBlockCntnr.querySelector("form");
        form.requestSubmit();
    }
}
